React = require 'react'
t = require('views/internal/recup-with-helpers')('home')

module.exports = class TeamCardsAssignedContainer extends React.Component
  displayName: 'TeamCardsAssignedContainer'

  render: t.renderable ->
    { orgName, orgId } = @props

    t.div ->
      t.div -> t.text '<TeamCardsAssignedContainer>' # TMON-885 Assigned tab content
      t.div -> t.text 'orgName: ' + orgName
      t.div -> t.text 'orgId: ' + orgId



// WEBPACK FOOTER //
// ./app/scripts/views/home/team-cards-assigned-container.coffee